import { Teacher } from './teacher.model';
import { from } from 'rxjs';
import { File } from './file';
import { Translator } from './translator';
export class Course extends Translator {
    id:string = ""
    nameEn:string = ""
    nameKh:string = ""
    length:number = 0
    price:number = 0 
    discountPrice:string = ""
    effort:string = "N/A"
    level:string  = "N/A"
    language:string  = "N/A"
    image:File
    teacher:Teacher
    descriptionEn:string = ""
    descriptionKh:string = ""
    studentsCount:number = 0
    youtubeId:string = ""
    createdAt:any
    audioUrl:string = ""
    audio:any = null
    constructor(){
        super()
    }
    get name():string{
        return this.translate(this.nameEn,this.nameKh)
    }
    get description():string {
        return this.translate(this.descriptionEn,this.descriptionKh)
    }
    get discountPriceValue():number{
        if (this.discountPrice == ''){
            return 0
        }
        return parseFloat(this.discountPrice)
    }
    mapping = () => {
        let teacher = new Teacher()
        Object.assign(teacher,this.teacher)
        this.teacher = teacher
    }

    checkDiscountPrice():boolean{
        return  this.discountPriceValue != 0 && this.discountPriceValue < this.price
    }

    getShowPrice():number{
        return this.checkDiscountPrice() ? this.discountPriceValue : this.price
    }
}